import { motion } from "framer-motion";
import founderPhoto from "@/assets/signature-photo.jpg";

const FounderV2 = () => (
  <section
    id="a-propos"
    aria-labelledby="fondateur-titre"
    className="scroll-mt-24 py-14 md:border-t md:border-border/60 md:py-24"
  >
    <div className="mx-auto max-w-[1180px] px-5 md:px-8">
      <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-primary">
        Derrière Agence 80/20
      </p>

      <div className="mt-6 grid gap-7 md:mt-8 md:grid-cols-[0.38fr_0.62fr] md:items-end md:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <img
            src={founderPhoto}
            alt="Maxim Rousseau, fondateur d'Agence 80/20"
            loading="lazy"
            decoding="async"
            className="aspect-[4/3] w-full object-cover object-top grayscale-[15%] md:aspect-[4/5]"
          />
          <p className="mt-4 flex items-baseline gap-3">
            <span className="text-sm font-semibold text-foreground">Maxim Rousseau</span>
            <span className="text-xs text-muted-foreground">Fondateur</span>
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.6, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2
            id="fondateur-titre"
            className="text-[1.6rem] font-semibold leading-[1.12] tracking-tight text-foreground md:text-[3.25rem]"
          >
            Une agence bâtie autour
            <br className="hidden md:block" /> d'un principe simple.
          </h2>

          <div className="mt-6 h-px w-full bg-border/70 md:mt-8" />

          <p className="mt-6 max-w-2xl text-[0.95rem] leading-[1.55] text-muted-foreground md:mt-8 md:text-lg">
            Produire davantage ne garantit pas que les bonnes actions sont exécutées. Agence 80/20 a été créée pour
            trouver les leviers qui ont réellement un impact, puis connecter la stratégie et l'exécution autour d'un
            même objectif.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);

export default FounderV2;
